import api from "./axiosInstance";

export function listNFTs(ownerId, { includeConsigned = false } = {}) {
  const params = ownerId ? { owner_id: ownerId } : {};
  if (includeConsigned) {
    params.include_consigned = true;
  }
  return api.get("/nft", { params });
}

export function fetchPublicOwnerCollection(numistrailId) {
  return api.get(`/nft/owners/${encodeURIComponent(numistrailId)}/public`, { skipAuth: true });
}

export function mintNFT(payload) {
  return api.post("/nft", payload);
}

export function fetchGradingCatalog() {
  return api.get("/nft/grading/catalog");
}

export function searchCountryAuthorities({ query, gradingSystem, limit = 20 } = {}) {
  const params = {};
  if (query) params.q = query;
  if (gradingSystem) params.grading_system = gradingSystem;
  if (limit) params.limit = limit;
  return api.get("/nft/country-authorities", { params });
}

export function searchMints({ query, gradingSystem, countryRefCode, year, limit = 20 } = {}) {
  const params = {};
  if (query) params.q = query;
  if (gradingSystem) params.grading_system = gradingSystem;
  if (countryRefCode) params.country_ref_code = countryRefCode;
  if (year !== undefined && year !== null && year !== "") params.year = year;
  if (limit) params.limit = limit;
  return api.get("/nft/mints", { params });
}

export function transferNFT(certificationNumber, certificationAuthority, recipientId, options = {}) {
  const payload = {
    certification_number: certificationNumber,
    certification_authority: certificationAuthority,
  };
  if (options.recipientEmail) {
    payload.recipient_email = options.recipientEmail;
  } else if (recipientId) {
    payload.recipient = recipientId;
  }
  if (options.nftId) {
    payload.nft_id = options.nftId;
  }
  if (options.consignment) {
    payload.consignment = true;
  }
  if (options.consignmentReturn) {
    payload.consignment_return = true;
  }
  return api.post("/nft/transfer", payload);
}

export function fetchNFTDetail(nftId) {
  return api.get(`/nft/${nftId}`);
}

export function updateNFT(nftId, payload) {
  return api.patch(`/nft/${nftId}/edit`, payload);
}

export function createNote(nftId, payload) {
  return api.post(`/nft/${nftId}/notes`, payload);
}

export function createExposure(nftId, payload) {
  return api.post(`/nft/${nftId}/exposures`, payload);
}

export function fetchExposure(exposureId) {
  return api.get(`/nft/exposures/${exposureId}`);
}

export function cancelExposure(exposureId) {
  return api.delete(`/nft/exposures/${exposureId}`);
}

export function fetchExposureQr(exposureId) {
  return api.get(`/nft/exposures/${exposureId}/qr`);
}

export function verifyExposureToken(payload) {
  return api.post(`/nft/exposures/verify`, { payload });
}

export function updateVisibility(nftId, isPublic) {
  return api.put(`/nft/${nftId}/visibility`, { is_public: Boolean(isPublic) });
}

export function updateOwnerCollectionVisibility(isPublic) {
  return api.put("/nft/visibility/owner", { is_public: Boolean(isPublic) });
}

export function updateOwnerGroupVisibility(groupId, isPublic) {
  return api.put(`/nft/groups/${groupId}/visibility`, { is_public: Boolean(isPublic) });
}

export function listOwnerGroups() {
  return api.get("/nft/groups");
}

export function createOwnerGroup(payload) {
  return api.post("/nft/groups", payload);
}

export function updateOwnerGroup(groupId, payload) {
  return api.patch(`/nft/groups/${groupId}`, payload);
}

export function deleteOwnerGroup(groupId) {
  return api.delete(`/nft/groups/${groupId}`);
}

export function listOwnerGroupAssignments() {
  return api.get("/nft/groups/assignments");
}

export function bulkOwnerGroupAssignments(payload) {
  return api.post("/nft/groups/assignments/bulk", payload);
}
